// @flow

import type { Merchant } from '../types';
import { getMerchantConfig } from '../get-merchant-config';

export function shouldCheckForPaymentConfirmation(merchant: Merchant): boolean {
  const merchantConfig = getMerchantConfig(merchant);

  return merchantConfig
    ? Boolean(merchantConfig.enable_check_for_confirmation_on_checkout)
    : false;
}
